import { ACCEPTED_CURRENCY, Blockchain } from '~/store/landing/types'
import { BANK_TRANSFER_NETWORK } from '~/types'
import { TransferMethod } from '~/types/deposit'
import { TransferStateStatus } from '~/types/transfer'

export type State = {
  bankNetwork: BANK_TRANSFER_NETWORK | null
  blockchainNetwork: Blockchain | null
  currency: ACCEPTED_CURRENCY | null
  status: TransferStateStatus
  transferMethod: TransferMethod | null
}

export enum DEPOSIT_ACTIONS {
  SET_BANK_NETWORK = 'DEPOSIT_ACTIONS.SET_BANK_NETWORK',
  SET_BLOCKCHAIN_NETWORK = 'DEPOSIT_ACTIONS.SET_BLOCKCHAIN_NETWORK',
  SET_CURRENCY = 'DEPOSIT_ACTIONS.SET_CURRENCY',
  SET_STATUS = 'DEPOSIT_ACTIONS.SET_STATUS',
  SET_TRANSFER_METHOD = 'DEPOSIT_ACTIONS.SET_TRANSFER_METHOD',
  RESET_DEPOSIT = 'DEPOSIT_ACTIONS.RESET_DEPOSIT',
}

export type SetBankNetwork = {
  type: typeof DEPOSIT_ACTIONS.SET_BANK_NETWORK
  payload: BANK_TRANSFER_NETWORK | null
}

export type SetBlockchainNetwork = {
  type: typeof DEPOSIT_ACTIONS.SET_BLOCKCHAIN_NETWORK
  payload: Blockchain | null
}

export type SetCurrency = {
  type: typeof DEPOSIT_ACTIONS.SET_CURRENCY
  payload: ACCEPTED_CURRENCY | null
}

export type SetStatus = {
  type: typeof DEPOSIT_ACTIONS.SET_STATUS
  payload: TransferStateStatus
}

export type SetTransferMethod = {
  type: typeof DEPOSIT_ACTIONS.SET_TRANSFER_METHOD
  payload: TransferMethod | null
}

export type ResetDeposit = {
  type: typeof DEPOSIT_ACTIONS.RESET_DEPOSIT
}

export type ActionTypes =
  | SetBankNetwork
  | SetBlockchainNetwork
  | SetCurrency
  | SetStatus
  | SetTransferMethod
  | ResetDeposit
